import classNames from 'classnames';
import defined from 'defined';
import React from 'react';
import PropTypes from 'prop-types';

import ClimatogramPlot from './ClimatogramPlot';

const Climatogram = ({
  tempData,
  precipData,
  compact,
  displayHeader}) => {
  return (
    <div className="Climatogram">

      <div className={classNames("Climatogram__header", {
                                  "Climatogram--hidden": !displayHeader,
                                })}
      >
        <p className="Climatogram__title">
          Climatogram
        </p>
      </div>

      <div className="Climatogram__graphArea">

        <ClimatogramPlot
          tempData={tempData}
          precipData={precipData}
          compact={compact}
        />

        <div className="Climatogram__noDataContainer">
          <p className={classNames("Climatogram__noDataLabel", {
                                      "Climatogram--hidden": hasClimateData(tempData, precipData),
                                    })}
          >
            No climate data is available for this location.
          </p>
        </div>

      </div>

    </div>
  );
};

function hasClimateData(tempData, precipData) {
  return  (defined(tempData) && tempData.length > 0) ||
          (defined(precipData) && precipData.length > 0);
}

Climatogram.PropTypes = {
  tempData: PropTypes.array,
  precipData: PropTypes.array,
  compact: PropTypes.bool,
  displayHeader: PropTypes.bool,
};

export default Climatogram;



// WEBPACK FOOTER //
// ./src/components/Climatogram.js